/* Mobile nav drawer. Nothing else on the homepage needs script, and the cart
   count is rendered server side, so this stays deliberately small. */
(function () {
  var burger = document.querySelector('[data-tz-burger]');
  var nav = document.querySelector('[data-tz-nav]');
  if (!burger || !nav) return;
  burger.addEventListener('click', function () {
    var open = nav.classList.toggle('is-open');
    burger.setAttribute('aria-expanded', String(open));
  });
})();

/* Product page variant picker. Swatches and pills instead of selects, so the
   selection has to be resolved here: it updates the price, the add to cart
   button, the URL, and above all the main photograph, which swaps the moment a
   colour is chosen. */
(function () {
  var data = document.querySelector('[data-tz-variants]');
  var idIn = document.querySelector('[data-tz-id]');
  if (!data || !idIn) return;

  var variants;
  try { variants = JSON.parse(data.textContent); } catch (e) { return; }
  if (!variants || !variants.length) return;

  var inputs = [].slice.call(document.querySelectorAll('[data-tz-input]'));
  var mainImg = document.querySelector('[data-tz-main-img]');
  var thumbs = [].slice.call(document.querySelectorAll('.tz-thumb'));
  var priceEl = document.querySelector('[data-tz-price]');
  var cmpEl = document.querySelector('[data-tz-compare]');
  var atc = document.querySelector('[data-tz-atc]');
  var optCount = 0;
  inputs.forEach(function (i) { optCount = Math.max(optCount, +i.dataset.tzInput + 1); });

  function chosen() {
    var out = [];
    for (var i = 0; i < optCount; i++) {
      var hit = document.querySelector('[data-tz-input="' + i + '"]:checked');
      out.push(hit ? hit.value : null);
    }
    return out;
  }

  function match(sel) {
    for (var i = 0; i < variants.length; i++) {
      var ok = true;
      for (var j = 0; j < sel.length; j++) {
        if (sel[j] !== null && variants[i].opts[j] !== sel[j]) { ok = false; break; }
      }
      if (ok) return variants[i];
    }
    return null;
  }

  var gridGal = document.querySelector('[data-tz-grid-gal]');
  function showImage(url, id) {
    if (gridGal && gridGal.offsetParent !== null && id != null) {
      var fig = gridGal.querySelector('[data-id="' + id + '"]');
      if (fig) fig.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    if (url && mainImg && mainImg.getAttribute('src') !== url) mainImg.src = url;
    thumbs.forEach(function (t) {
      t.classList.toggle('is-on', id != null && String(t.dataset.id) === String(id));
    });
  }

  /* A value is struck through when no variant that carries it, together with
     everything else already chosen, is in stock. */
  function markStock(sel) {
    inputs.forEach(function (inp) {
      var oi = +inp.dataset.tzInput;
      var probe = sel.slice();
      probe[oi] = inp.value;
      var any = variants.some(function (vr) {
        if (!vr.ok) return false;
        for (var j = 0; j < probe.length; j++) {
          if (j !== oi && probe[j] !== null && vr.opts[j] !== probe[j]) return false;
        }
        return vr.opts[oi] === inp.value;
      });
      var lbl = inp.closest('label');
      if (lbl) lbl.classList.toggle('is-out', !any);
    });
  }

  function paint() {
    inputs.forEach(function (inp) {
      var lbl = inp.closest('label');
      if (lbl) lbl.classList.toggle('is-sel', inp.checked);
    });
  }

  function apply(initial) {
    var sel = chosen();
    paint();
    markStock(sel);

    for (var i = 0; i < optCount; i++) {
      var out = document.querySelector('[data-tz-optval="' + i + '"]');
      if (out && sel[i]) out.textContent = sel[i];
    }

    var vr = match(sel);
    if (!vr) {
      if (atc) { atc.disabled = true; atc.textContent = 'הצירוף הזה אינו זמין'; }
      return;
    }

    idIn.value = vr.id;
    if (priceEl) priceEl.textContent = vr.price;
    var ie = document.querySelector('[data-tz-inst]'); if (ie && vr.inst) ie.textContent = vr.inst;
    var sp = document.querySelector('[data-tz-sticky-price]'); if (sp) sp.textContent = vr.price;
    if (cmpEl) {
      if (vr.cmp) { cmpEl.textContent = vr.cmp; cmpEl.hidden = false; }
      else cmpEl.hidden = true;
    }
    if (atc) {
      atc.disabled = !vr.ok;
      atc.textContent = vr.ok ? 'הוספה לסל' : 'אזל מהמלאי';
    }
    /* on first load keep the gallery's lead photo (on body); swap only when a colour is picked */
    if (!initial) showImage(vr.img, vr.imgId);

    if (window.history && history.replaceState) {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', vr.id);
      history.replaceState({}, '', u);
    }
  }

  inputs.forEach(function (inp) { inp.addEventListener('change', function () { apply(false); }); });

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { showImage(t.dataset.full, t.dataset.id); });
  });

  /* size guide */
  var sg = document.querySelector('[data-tz-sg]');
  var openBtn = document.querySelector('[data-tz-guide]');
  if (sg && openBtn) {
    openBtn.addEventListener('click', function () { sg.hidden = false; });
    [].slice.call(sg.querySelectorAll('[data-tz-sg-close]')).forEach(function (c) {
      c.addEventListener('click', function () { sg.hidden = true; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') sg.hidden = true;
    });
  }

  apply(true);
})();

/* Collection facets. The store has no storefront filter set, and the catalogue
   fits on one page, so the facets are applied here: nothing reloads and no
   filter URL can 404. Sorting is Shopify's own, because that has to hold across
   pagination. */
(function () {
  var bar = document.querySelector('[data-tz-bar]');
  var grid = document.querySelector('[data-tz-grid]');
  if (!bar || !grid) return;

  var cards = [].slice.call(grid.querySelectorAll('.tz-card'));
  var facets = [].slice.call(bar.querySelectorAll('[data-tz-facet]'));
  var clear = bar.querySelector('[data-tz-clear]');
  var count = bar.querySelector('[data-tz-count]');
  var none = document.querySelector('[data-tz-none]');

  function picked(f) {
    return [].slice.call(f.querySelectorAll('input:checked')).map(function (i) { return i.value; });
  }

  /* A card passes a facet when it carries at least one of the chosen values,
     and passes overall only when every active facet is satisfied. */
  function apply() {
    var active = facets.map(function (f) {
      return { key: f.dataset.tzFacet, vals: picked(f) };
    });
    var any = false;
    var shown = 0;

    cards.forEach(function (c) {
      var ok = true;
      active.forEach(function (a) {
        if (!a.vals.length) return;
        any = true;
        var have = (c.dataset[a.key] || '').split('|').filter(Boolean);
        var hit = a.vals.some(function (v) { return have.indexOf(v) !== -1; });
        if (!hit) ok = false;
      });
      c.classList.toggle('is-hid', !ok);
      if (ok) shown++;
    });

    facets.forEach(function (f) { f.classList.toggle('is-on', picked(f).length > 0); });
    if (clear) clear.hidden = !any;
    if (count) count.textContent = shown + (shown === 1 ? ' פריט' : ' פריטים');
    if (none) none.hidden = shown > 0;
  }

  facets.forEach(function (f) {
    var btn = f.querySelector('.tz-facet-btn');
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = f.classList.contains('is-open');
      facets.forEach(function (o) { o.classList.remove('is-open'); });
      f.classList.toggle('is-open', !open);
      btn.setAttribute('aria-expanded', String(!open));
    });
    f.addEventListener('change', apply);
    f.querySelector('.tz-facet-pop').addEventListener('click', function (e) { e.stopPropagation(); });
  });

  document.addEventListener('click', function () {
    facets.forEach(function (f) { f.classList.remove('is-open'); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') facets.forEach(function (f) { f.classList.remove('is-open'); });
  });

  if (clear) {
    clear.addEventListener('click', function () {
      bar.querySelectorAll('input:checked').forEach(function (i) { i.checked = false; });
      apply();
    });
  }

  var sort = bar.querySelector('[data-tz-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sort.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  }
})();


/* Phones: a sticky add-to-cart bar appears once the real button has scrolled out of view. */
(function () {
  var bar = document.querySelector('[data-tz-sticky]');
  var atc = document.querySelector('[data-tz-atc]');
  if (!bar || !atc || !('IntersectionObserver' in window)) return;
  var mq = window.matchMedia('(max-width: 760px)');
  new IntersectionObserver(function (es) {
    var e = es[0];
    bar.hidden = !(mq.matches && !e.isIntersecting && e.boundingClientRect.top < 0);
  }).observe(atc);
})();

/* Collection page, direction C: facets, style tabs, tone buttons, load more, filter sheet, sort. */
(function () {
  var grid = document.querySelector('[data-c-grid]');
  if (!grid) return;
  var PAGE = 12;
  var cards = [].slice.call(grid.querySelectorAll('.c-card'));
  var bar = document.querySelector('[data-c-bar]');
  var facets = bar ? [].slice.call(bar.querySelectorAll('[data-c-facet]')) : [];
  var tones = bar ? [].slice.call(bar.querySelectorAll('[data-c-tone]')) : [];
  var tabs = [].slice.call(document.querySelectorAll('[data-c-tab]'));
  var clear = document.querySelector('[data-c-clear]');
  var none = document.querySelector('[data-c-none]');
  var more = document.querySelector('[data-c-more]');
  var moreTxt = document.querySelector('[data-c-more-txt]');
  var counts = [].slice.call(document.querySelectorAll('[data-c-count],[data-c-count2]'));
  var scrim = document.querySelector('[data-c-scrim]');
  var expanded = false;
  var tab = { kind: '', val: '' };

  function picked(f) { return [].slice.call(f.querySelectorAll('input:checked')).map(function (i) { return i.value; }); }
  function tabHit(c) {
    if (!tab.kind) return true;
    if (tab.kind === 'mat') return (c.dataset.material || '').indexOf(tab.val) !== -1;
    if (tab.kind === 'tag') { var g = c.dataset.tags || ''; return tab.val.split('/').some(function (a) { return g.indexOf('|' + a + '|') !== -1; }); }
    if (tab.kind === 'pr') { var r = tab.val.split('-'), p = +c.dataset.price; return p >= +r[0] && p < +r[1]; }
    var t = c.dataset.title || '';
    return tab.val.split('/').some(function (a) { return t.indexOf(a) !== -1; });
  }
  function apply() {
    var active = facets.map(function (f) { return { key: f.dataset.cFacet, vals: picked(f) }; });
    var any = active.some(function (a) { return a.vals.length; });
    var ok = cards.filter(function (c) {
      var pass = tabHit(c) && active.every(function (a) {
        if (!a.vals.length) return true;
        var have = (c.dataset[a.key] || '').split('|').filter(Boolean);
        return a.vals.some(function (v) { return have.indexOf(v) !== -1; });
      });
      c.classList.toggle('is-hid', !pass);
      c.classList.remove('is-more');
      return pass;
    });
    if (!expanded) ok.slice(PAGE).forEach(function (c) { c.classList.add('is-more'); });
    var shown = expanded ? ok.length : Math.min(PAGE, ok.length);
    if (more) {
      more.hidden = expanded || ok.length <= PAGE;
      if (moreTxt) moreTxt.textContent = 'מוצגים ' + shown + ' מתוך ' + ok.length + ' פריטים';
    }
    counts.forEach(function (el) { el.textContent = ok.length; });
    facets.forEach(function (f) { f.classList.toggle('is-on', picked(f).length > 0); });
    var matF = facets.filter(function (f) { return f.dataset.cFacet === 'material'; })[0];
    var matVals = matF ? picked(matF) : [];
    tones.forEach(function (t) { t.setAttribute('aria-pressed', String(matVals.indexOf(t.dataset.cTone) !== -1)); });
    if (clear) clear.hidden = !any;
    if (none) none.hidden = ok.length > 0;
  }
  facets.forEach(function (f) {
    var btn = f.querySelector('.c-facet-btn');
    btn.addEventListener('click', function (e) {
      if (document.body.classList.contains('c-sheet-open')) return;
      e.stopPropagation();
      var open = f.classList.contains('is-open');
      facets.forEach(function (o) { o.classList.remove('is-open'); });
      f.classList.toggle('is-open', !open);
      btn.setAttribute('aria-expanded', String(!open));
    });
    f.addEventListener('change', apply);
    f.querySelector('.c-facet-pop').addEventListener('click', function (e) { e.stopPropagation(); });
  });
  document.addEventListener('click', function () { facets.forEach(function (f) { f.classList.remove('is-open'); }); });
  tones.forEach(function (t) {
    t.addEventListener('click', function () {
      var inp = bar.querySelector('[data-c-facet="material"] input[value="' + t.dataset.cTone + '"]');
      if (inp) { inp.checked = !inp.checked; apply(); }
    });
  });
  tabs.forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      tabs.forEach(function (x) { x.removeAttribute('aria-current'); });
      a.setAttribute('aria-current', 'true');
      tab = { kind: a.dataset.kind, val: a.dataset.val };
      expanded = false; apply();
    });
  });
  if (clear) clear.addEventListener('click', function () {
    bar.querySelectorAll('input:checked').forEach(function (i) { i.checked = false; }); apply();
  });
  var mb = document.querySelector('[data-c-more-btn]');
  if (mb) mb.addEventListener('click', function () { expanded = true; apply(); });
  function sheet(open) {
    document.body.classList.toggle('c-sheet-open', open);
    if (scrim) scrim.hidden = !open;
  }
  document.querySelectorAll('[data-c-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); sheet(true); }); });
  document.querySelectorAll('[data-c-close]').forEach(function (b) { b.addEventListener('click', function () { sheet(false); }); });
  if (scrim) scrim.addEventListener('click', function () { sheet(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { sheet(false); facets.forEach(function (f) { f.classList.remove('is-open'); }); } });
  document.querySelectorAll('[data-c-sort]').forEach(function (s) {
    s.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', s.value); u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  });
  apply();
})();

/* nav dropdown toggles (mobile drawer) */
(function(){document.querySelectorAll('[data-tz-subtg]').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();var li=b.parentNode;var o=li.classList.toggle('is-sub-open');b.setAttribute('aria-expanded',o?'true':'false');});});})();
/* collection deep link: ?tab=<label> opens that tab */
(function(){try{var t=new URLSearchParams(location.search).get('tab');if(!t)return;var a=[].slice.call(document.querySelectorAll('[data-c-tab]')).filter(function(x){return x.textContent.trim()===t;})[0];if(a)a.click();}catch(e){}})();
